import { defineStore } from 'pinia';

export const useCaretStore = defineStore({
  id: 'caret_store',
  state: () => ({
    caretStartOffset: 0,
    caretEndOffset: 0,
    caretPositionName: null,
    caretPositionNum: 0,

    preCaretStartOffset: 0,
    preCaretEndOffset: 0,
    preCaretPositionName: null,
    preCaretPositionNum: 0,

    isSelectionDelete: false,
    composingStatus: 'FALSE', // FALSE / TRUE / KEEP_IT_TRUE
  }),
});
